import { deletePositionUseCase } from '@src/main/modules/parameters/application/delete/delete-position.usecase';
import { createPositionHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/PositionHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDeletePosition = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createPositionHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (id: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await deletePositionUseCase(id, tokenProvider);
    },
  });
};
